<template>
  <div class="page">
    <h3 class="fc-text-sm fc-color-gray-light fc-pad-t-big fc-pad">{{$t('m.common-problem')}}</h3>
    <div class="fc-text-usual fc-bg-fff fc-pad fc-pad-t-sm fc-color-gray-dark">
      <p class="fc-pad-b-min">{{$t('m.whether-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-whether-account')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-money')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-time')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-shot')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.recharge-wrong')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-recharge-wrong')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.refund')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-refund')}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'asks',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
    },
    methods: {

    },

  }
</script>

<style scoped>
  /* @import url("/static/css/common.css"); */
  .page {
    background: #F7F7F7;
    line-height: .48rem;
  }

  .hr-line {
    border: 0.01rem solid #F3F3F3;
    margin: .18rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/asks.vue